import { useLocale } from '../../app/locale/LocaleProvider';
import { ResultCards } from './ResultCards';
import type { ScoreVector } from '../../data/dimensions';
import type { ScoreEventInput } from '../../engine/scoring';

function readResult() {
  const raw = sessionStorage.getItem('vibeArcade.latestResult');
  if (!raw) return { typeId: 'joke_shield_deflector' };
  try {
    const parsed = JSON.parse(raw) as {
      events?: ScoreEventInput[];
      scores?: ScoreVector;
      match?: { primary?: { typeId?: string } };
    };
    return {
      typeId: parsed.match?.primary?.typeId ?? 'joke_shield_deflector',
      scores: parsed.scores,
      events: Array.isArray(parsed.events) ? parsed.events : []
    };
  } catch {
    return { typeId: 'joke_shield_deflector' };
  }
}

export function ResultPage() {
  const { locale } = useLocale();
  const result = readResult();

  return (
    <main className="result-page">
      <ResultCards typeId={result.typeId} locale={locale} scores={result.scores} events={result.events} />
    </main>
  );
}
